import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, Directive } from '@angular/core';
import { Router } from '@angular/router';
import { SaveReportInputDto } from 'app/ReportingModel/SavedReportDto';
import { AuthService } from 'app/shared/auth/auth.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Observable, of, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GenerateReportInputDto, DownloadReportInputDto } from 'app/ReportingModel/GenerateReportDto';
import { UltimateCustomerDto, UltimateCustomerSearchDto } from 'app/ReportingModel/UltimateCustomerDto';
import { CustomerDto, CustomerSearchDto } from 'app/ReportingModel/CustomerDto';
import { SearchResourceResultDto, SearchResourceDto } from 'app/ReportingModel/SearchResourceDto';
import { SearchCouncellorResultDto, SearchCouncellorDto } from 'app/ReportingModel/SearchCouncellorDto';
import { SearchEngagementResultDto, SearchEngagementDto } from 'app/ReportingModel/SearchEngagementDto';
import { SearchBookingDto, SearchBookingResultDto } from 'app/ReportingModel/SearchBookingDto';
import { SearchMERABookingDto, SearchMERABookingResultDto } from 'app/ReportingModel/SearchMERABookingDto';
import { EmployeeDepartmentSearchDto, SearchEmployeeDepartmentResultDto } from 'app/ReportingModel/EmployeeDepartmentSearchDto';
import { DeleteQueueFilterDto, DeleteSavedFilterDto } from 'app/ReportingModel/ReportFiltering';

@Directive()
@Injectable({
  providedIn: 'root'
})
export class ReportingService extends BehaviorSubject<any> {

  endpoint = environment.apiEndpoint;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
  };

  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private router: Router,
    private spinner: NgxSpinnerService) {
    super(null);
  }

  private navigateToReportparentSource = new Subject<void>();
  navigateToReportparent$ = this.navigateToReportparentSource.asObservable();

  triggerNavigateToReportparent() {
    this.navigateToReportparentSource.next();
  }
  private getAPI(actionName: string): string {
    this.auth.checkTokenExpiredAndRefresh();
    return this.endpoint + 'Report/' + actionName;
  }

  savedReport(report: SaveReportInputDto): Observable<any> {
    return this.http
      .post<any>(
        this.getAPI('SaveReportData'),
        report,
        this.httpOptions
      )
      .pipe(
        map((data) => data),
        catchError(this.handleError<any>('SaveReportData'))
      );
  }

  GetSavedReports(reportId: any): Observable<any> {
    //alert('calling GetSavedReports API');
    return this.http
      .get<any[]>(
        this.getAPI('GetSavedReports?reportId=' + reportId),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          //alert('API Result GetSavedReports' + JSON.stringify(data));
          return data;
        }
        ),
        catchError(this.handleError<any>('FetchPrivacyNotice'))
      );
  }

  GetReportMenus(roleId: any): Observable<any> {
    return this.http
      .get<any[]>(
        this.getAPI('GetReportMenus?roleId=' + roleId),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('FetchPrivacyNotice'))
      );
  }
  GetReportCount(roleId: any): Observable<any> {
    return this.http
      .get<any[]>(
        this.getAPI('GetReportCount?roleId=' + roleId),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('FetchPrivacyNotice'))
      );
  }

  GenerateReport(report: GenerateReportInputDto): Observable<Blob> {
    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/json'
    );
    let url =
      this.getAPI('GenerateReport');
    return this.http.post<any>(url, report, { headers, observe: 'response', responseType: 'blob' as 'json' }).pipe(
      map((data) => data),
      catchError(this.handleError<any>('GenerateReport'))
    );
  }

  GetResourceMasters(roleId: any): Observable<any> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceMasters'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceMasters'))
      );
  }

  GetResourceCompanyCode(CountryCode: any[]): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceCompanyCode?input=' + JSON.stringify(CountryCode)),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceCompanyCode'))
      );
  }



  GetResourceCompetency(ServiceLineCode: any[], SubServiceLineCode: any[]): Observable<any> {
     let params = new HttpParams()
      .set('input', JSON.stringify(ServiceLineCode))
      .set('input2', JSON.stringify(SubServiceLineCode));

      return this.http.get<any[]>(this.getAPI('GetResourceCompetency'), { params })
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceCompanyCode'))
      );
  }


  GetJobCompetency(ServiceLineCode: any[],SubServiceLineCode: any[]): Observable<any[]> {
    let params = new HttpParams()
    .set('input', JSON.stringify(ServiceLineCode))
    .set('input2', JSON.stringify(SubServiceLineCode));

    return this.http.get<any[]>(this.getAPI('GetJobCompetency'), { params })
    .pipe(
      map((data) => {
        return data;
      }
      ),
      catchError(this.handleError<any>('GetJobCompetency'))
    );
    }

  GetResourceCostCenter(ServiceLineCode: any[],SubServiceLineCode: any[],
    CompetencyCode: any[],SubAreaCode: any[],CountryCode: any[]): Observable<any[]> {

      let params = new HttpParams()
      .set('ServiceLineCode', JSON.stringify(ServiceLineCode))
      .set('SubServiceLineCode', JSON.stringify(SubServiceLineCode))
      .set('CompetencyCode', JSON.stringify(CompetencyCode))
      .set('SubAreaCode', JSON.stringify(SubAreaCode))
      .set('CountryCode', JSON.stringify(CountryCode));

     return this.http.get<any[]>(this.getAPI('GetResourceCostCenter'), { params })
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceCostCenter'))
      );
  }

  GetJobCostCenter(ServiceLineCode: any[],SubServiceLineCode: any[],
    CompetencyCode: any[],SubAreaCode: any[],CountryCode: any[]): Observable<any[]> {

      let params = new HttpParams()
      .set('ServiceLineCode', JSON.stringify(ServiceLineCode))
      .set('SubServiceLineCode', JSON.stringify(SubServiceLineCode))
      .set('CompetencyCode', JSON.stringify(CompetencyCode))
      .set('SubAreaCode', JSON.stringify(SubAreaCode))
      .set('CountryCode', JSON.stringify(CountryCode));

      return this.http.get<any[]>(this.getAPI('GetJobCostCenter'), { params })
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetJobCostCenter'))
      );
  }


  GetResourceCountry(SubAreaCode: any[]): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceCountry?input=' + JSON.stringify(SubAreaCode)),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceCountry'))
      );
  }

  // GetResourceDepartment(CountryCode: any[]): Observable<any[]> {
  //   return this.http
  //     .get<any[]>(
  //       this.getAPI('GetResourceDepartment?input=' + JSON.stringify(CountryCode)),
  //       this.httpOptions
  //     )
  //     .pipe(
  //       map((data) => {
  //         return data;
  //       }
  //       ),
  //       catchError(this.handleError<any>('GetResourceDepartment'))
  //     );
  // }


  
  GetResourceDepartment(department: EmployeeDepartmentSearchDto): Observable<any> {
    return this.http
      .post<SearchEmployeeDepartmentResultDto[]>(
        this.getAPI('GetResourceDepartment'),
        department,
        this.httpOptions
      )
      .pipe(
        map((data) => data),
        catchError(this.handleError<any>('GetResourceDepartment'))
      );
  }



  GetResourceEconomicLocation(CountryCode: any[]): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceEconomicLocation?input=' + JSON.stringify(CountryCode)),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceEconomicLocation'))
      );
  }

  GetResourceOfficeLocation(CountryCode: any[]): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceOfficeLocation?input=' + JSON.stringify(CountryCode)),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceOfficeLocation'))
      );
  }

  GetResourceSubServiceLine(ServiceLineCode: any[]): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceSubServiceLine?input=' + JSON.stringify(ServiceLineCode)),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceSubServiceLine'))
      );
  }

  GetJobSubServiceLine(ServiceLineCode: any[]): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetJobSubServiceLine?input=' + JSON.stringify(ServiceLineCode)),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetJobSubServiceLine'))
      );
  }


  GetResourceSubArea(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceSubArea'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceSubArea'))
      );
  }

  GetJobSubArea(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetJobSubArea'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetJobSubArea'))
      );
  }


  GetJobStatus(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetJobStatus'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetJobStatus'))
      );
  }

  GetCustomerIndustry(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetCustomerIndustry'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetCustomerIndustry'))
      );
  }

  GetCustomerPriorityStatus(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetCustomerPriorityStatus'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetCustomerPriorityStatus'))
      );
  }

  GetResourceType(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceType'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceType'))
      );
  }

  GetResourceStatus(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceStatus'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceStatus'))
      );
  }

  GetResourceServiceLine(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceServiceLine'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceServiceLine'))
      );
  }

  GetJobServiceLine(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetJobServiceLine'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetJobServiceLine'))
      );
  }

  SearchUltimateCustomer(search: UltimateCustomerSearchDto): Observable<any> {
    return this.http
      .post<UltimateCustomerDto[]>(this.getAPI('SearchUltimateCustomer'), search, this.httpOptions)
      .pipe(
        map((data) => data),
        catchError(this.handleError<any>('SearchUltimateCustomer'))
      );
  }

  SearchCustomer(search: CustomerSearchDto): Observable<any> {
    return this.http
      .post<CustomerDto[]>(this.getAPI('SearchCustomer'), search, this.httpOptions)
      .pipe(
        map((data) => data),
        catchError(this.handleError<any>('SearchCustomer'))
      );
  }

  SearchResource(resource: SearchResourceDto): Observable<any> {
    return this.http
      .post<SearchResourceResultDto[]>(
        this.getAPI('SearchResource'),
        resource,
        this.httpOptions
      )
      .pipe(
        map((data) => data),
        catchError(this.handleError<any>('SearchResource'))
      );
  }


  SearchCouncellor(resource: SearchCouncellorDto): Observable<any> {
    return this.http
      .post<SearchCouncellorResultDto[]>(
        this.getAPI('SearchCouncellor'),
        resource,
        this.httpOptions
      )
      .pipe(
        map((data) => data),
        catchError(this.handleError<any>('SearchCouncellor'))
      );
  }

  SearchEngagement(resource: SearchEngagementDto): Observable<any> {
    return this.http
      .post<SearchEngagementResultDto[]>(
        this.getAPI('SearchEngagement'),
        resource,
        this.httpOptions
      )
      .pipe(
        map((data) => data),
        catchError(this.handleError<any>('SearchEngagement'))
      );
  }

  SearchBooking(resource: SearchBookingDto): Observable<any> {
    return this.http
      .post<SearchBookingResultDto[]>(
        this.getAPI('SearchBooking'),
        resource,
        this.httpOptions
      )
      .pipe(
        map((data) => data),
        catchError(this.handleError<any>('SearchBooking'))
      );
  }

  SearchMERABooking(resource: SearchMERABookingDto): Observable<any> {
    return this.http
      .post<SearchMERABookingResultDto[]>(
        this.getAPI('SearchMERABooking'),
        resource,
        this.httpOptions
      )
      .pipe(
        map((data) => data),
        catchError(this.handleError<any>('SearchMERABooking'))
      );
  }

  GetResourceLevel(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceLevel'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceLevel'))
      );
  }

  GetResourceGrade(rankCode: any[]): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceGrade?input=' + JSON.stringify(rankCode)),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceGrade'))
      );
  }
    
  GetResourceRank(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceRank'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceRank'))
      );
  }

  GetResourceGDSRegionAlignment(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceGDSRegionAlignment'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceGDSRegionAlignment'))
      );
  }

  GetJobCategoery(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetJobCategoery'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetJobCategoery'))
      );
  }

  GetJobType(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetJobType'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetJobType'))
      );
  }

  GetJobCountry(SubAreaCode: any[]): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetJobCountry?input=' + JSON.stringify(SubAreaCode)),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetJobCountry'))
      );
  }

  GetOtherBookingType(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetOtherBookingType'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetOtherBookingType'))
      );
  }

  GetOtherMERAAction(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetOtherMERAAction'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetOtherMERAAction'))
      );
  }

  GetOtherMeraRequestMode(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetOtherMeraRequestMode'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetOtherMeraRequestMode'))
      );
  }

  GetOtherMeraBookingStatus(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetOtherMeraBookingStatus'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetOtherMeraBookingStatus'))
      );
  }

  GetOtherMeraStatusInformation(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetOtherMeraStatusInformation'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetOtherMeraStatusInformation'))
      );
  }

  GetResourceSubRegion(): Observable<any[]> {
    return this.http
      .get<any[]>(
        this.getAPI('GetResourceSubRegion'),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceSubRegion'))
      );
  }

  GetResourceDetails(instanceId): Observable<any> {
    return this.http
      .get<any>(
        this.getAPI('GetResourceDetails?instanceId=' + instanceId),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetResourceDetails'))
      );
  }

  GenerateReportQueue(report: GenerateReportInputDto): Observable<any> {
    return this.http
    .post<any>(
      this.getAPI('GenerateReportQueue'),
      report,
      this.httpOptions
    )
    .pipe(
      map((data) => data),
      catchError(this.handleError<any>('GenerateReportQueue'))
    );
  }

  GetQueuedReports(reportId: any): Observable<any> {
    return this.http
      .get<any[]>(
        this.getAPI('GetQueuedReports?reportId=' + reportId),
        this.httpOptions
      )
      .pipe(
        map((data) => {
          return data;
        }
        ),
        catchError(this.handleError<any>('GetQueuedReports'))
      );
  }

  downloadReport(report: DownloadReportInputDto): Observable<Blob> {
    const headers = new HttpHeaders().set(
      'Content-Type',
      'application/json'
    );
    let url =
      this.getAPI('DownloadReport');
    return this.http.post<any>(url, report, { headers, observe: 'response', responseType: 'blob' as 'json' }).pipe(
      map((data) => data),
      catchError(this.handleError<any>('DownloadReport'))
    );
  }

  deleteSavedReport(model: DeleteSavedFilterDto): Observable<any> {
    return this.http
      .post<any>(
        this.getAPI('DeleteSavedReport'),
        model,
        this.httpOptions
      )
      .pipe(
        map((data) => data),
        catchError(this.handleError<any>('DeleteSavedReport'))
      );
  }


  deleteQueueReport(model: DeleteQueueFilterDto): Observable<any> {
    return this.http
      .post<any>(
        this.getAPI('DeleteQueueReport'),
        model,
        this.httpOptions
      )
      .pipe(
        map((data) => data),
        catchError(this.handleError<any>('DeleteQueueReport'))
      );
  }

  getDummyArray = (arrayList) => {
    if (!arrayList || arrayList.length <= 0) {
      return [];
    }
    return arrayList.map((element) => {
      return {
        ID: element.ID,
        Text: element.Text,
      };
    });
  };

  getDummyArrayWithCode = (arrayList) => {
    if (!arrayList || arrayList.length <= 0) {
      return [];
    }
    return arrayList.map((element) => {
      return {
        ID: element.ID,
        Text: element.Text,
        Code: element.Code
      };
    });
  };

  private handleError<T>(result?: T) {
    // return (error: any): Observable<T> => {
    //   console.error(error); // log to console instead
    //   return of(result as T);
    // };
    return (error: any): Observable<T> => {
      let status = '';
      let msg = '';
      if (Object.prototype.hasOwnProperty.call(error, 'status')) {
        status = error.status.toString();
      }
      if (typeof error.error === 'string') {
        msg = error.error;
      } else if (Object.prototype.hasOwnProperty.call(error.error, 'title')) {
        msg = error.error.title;
      } else if (
        Object.prototype.hasOwnProperty.call(error.error, 'customException')
      ) {
        msg = error.error.customException;
        msg +=
          `
          ` + JSON.stringify(error.error.customData);
      }
      if (status === '0' && (!msg || msg.trim().length === 0)) {
        msg = 'MERA Web API Service is down or inaccessible.';
      }

      let exceptionPrefix = '';
      if (status === '400') {
        exceptionPrefix = 'Unexpected error, please try later';
      }

      let alertMsg =
        `
      Response for MERA Web API Service - 
      Status Code: ` +
        status +
        `
      Message: ` +
        exceptionPrefix +
        ` - 
      ` +
        msg;

      alert(alertMsg);
      //alert(JSON.stringify(error)); //todo: remove/comment on prod
      console.error(alertMsg);
      console.error(JSON.stringify(error)); // log to console instead

      // if http response status is 401-Unauthorized
      if (status === '401') {
        this.router.navigate(['AccessError']);
      } else if (status === '0') {
        //MERA Web API Service is down or inaccessible.
        // todo: show diff page
        //this.router.navigate(['AccessError']);
      }

      this.spinner.hide();

      return of(result as T);
    };
  }
}
